import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=0c6afc38"
import script from "./Pricing.vue?vue&type=script&lang=ts"
export * from "./Pricing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6afc38')) {
      api.createRecord('0c6afc38', component.options)
    } else {
      api.reload('0c6afc38', component.options)
    }
    module.hot.accept("./Pricing.vue?vue&type=template&id=0c6afc38", function () {
      api.rerender('0c6afc38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/Pricing.vue"
export default component.exports